import React from 'react';
import Forgot from '../../../components/UI/Forgot/Forgot';
 
const ForgotPage = () => {
  return  <Forgot></Forgot>;
}

export default ForgotPage;